import {NonPaymentBlockingType, PrivateRoutingType, UpdateUserData} from "@/api";
import {FirstStageQuery, SecondStageQuery} from "./queries.generated";

export function createInitialData(
    extension?: FirstStageQuery["users"]["items"][number],
    groups?: SecondStageQuery["groups"]["items"],
): UpdateUserData {
    if (!extension)
        return {
            displayName: "",
            mobileNumber: "",
            homeNumber: "",
            notificationEmail: "",
            pin: "",
            alternateCallerNumberId: 0,
            locationId: 0,
            alias: "",
            featureRestrictions: [],
            secretaryNumberId: 0,
            groupMembershipGroupIds: [],
            previewFeaturesEnabled: false,
            cliro: false,
            connectedNumberPresentationRestrictionOverride: false,
            nationalCac: "",
            internationalCac: "",
            callLimit: 0,
            directInwardDialing: false,
            directOutwardDialing: false,
            privateRoutingType: PrivateRoutingType.PstnOnly,
            nonPaymentBlockingType: NonPaymentBlockingType.NotBlocked,
            outgoingCallBarringUser: [],
            outgoingCallBarringAdmin: [],
            outgoingCallBarringOperator: [],
            callWaiting: false,
            voicemailToEmailEnabled: false,
            hotNumber: "",
        };

    return {
        displayName: extension.displayName,
        mobileNumber: extension.mobileNumber,
        homeNumber: extension.homeNumber,
        notificationEmail: extension.notificationEmail || "",
        pin: extension.pin,
        alternateCallerNumberId: extension.alternateCallerNumberId || 0,
        locationId: extension.locationId,
        alias: extension.alias || "",
        featureRestrictions: extension.featuresRestrictions,
        secretaryNumberId: extension.secretaryNumberId || 0,
        groupMembershipGroupIds: groups?.map((g) => g.id),
        previewFeaturesEnabled: extension.previewFeaturesEnabled,
        cliro: extension.cliro,
        connectedNumberPresentationRestrictionOverride: extension.connectedNumberPresentationRestrictionOverride,
        nationalCac: extension.nationalCac,
        internationalCac: extension.internationalCac,
        callLimit: extension.callLimit,
        directInwardDialing: extension.directInwardDialing,
        directOutwardDialing: extension.directOutwardDialing,
        privateRoutingType: extension.privateRoutingType,
        nonPaymentBlockingType: extension.number.nonPaymentBlockingType,
        outgoingCallBarringUser: extension.outgoingCallBarringUser,
        outgoingCallBarringAdmin: extension.outgoingCallBarringAdmin,
        outgoingCallBarringOperator: extension.outgoingCallBarringOperator,
        callWaiting: extension.callWaiting,
        voicemailToEmailEnabled: extension.voicemailToEmailEnabled,
        hotNumber: extension.hotnumber,
    };
}
